import React from "react";
import styles from "./styles.module.scss";
import { Grid, GridColumn, GridToolbar,GridRowClickEvent, GridPageChangeEvent } from "@progress/kendo-react-grid";
import { useState, useEffect, useRef } from "react";
import { orderBy } from "@progress/kendo-data-query";
import { filterBy } from "@progress/kendo-data-query";
import {
    Menu,
    MenuItem,
    MenuItemLink,
    MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";

interface AlarmStatisticsGridProps {
    data:any;
    clickHandler?: any
}

const RunningPeriodsGrid = (props: AlarmStatisticsGridProps) => {
    const initialSort: any = [
        {
            field: "count",
            dir: "desc",
        },
    ];

    interface PageState {
        skip: number;
        take: number;
      }
      

    const initialDataState: PageState = { skip: 0, take: 20 };
    const [data, setData] = useState([]);
    const [sort, setSort] = useState(initialSort);
    const [filter, setFilter] = useState();
    const [page, setPage] = useState<PageState>(initialDataState);

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
      };

    const filterChange = (event: any) => {
        if (props.data != null) {
            setData(filterBy(props.data, event.filter));
            setFilter(event.filter);
        }
    };
    const _export = useRef<ExcelExport | null>(null);

    const excelExport = (event: MenuSelectEvent) => {
        if (event.item.text === "Export to Excel") {
            if (_export.current !== null) {
                _export.current.save();
            }
        }
    };

    function renderMenuIconIfApplicable(props: any) {
        return props.item.icon ? (
            <span
                style={{ fontSize: "16px" }}
                className={`k-icon k-i-${props.item.icon}`}
                role="presentation"
                key="0"
            />
        ) : null;
    }
    const linkRender = (props: any) => {
        return (
            <MenuItemLink url={props.item.url} opened={props.opened}>
                {[renderMenuIconIfApplicable(props), props.item.text, null]}
            </MenuItemLink>
        );
    };

    useEffect(() => {
        setData(props.data)
    }, [props.data]);

    if (data == null) {
        return <div>No data found for selected filters</div>;
    }

    return (
        <ExcelExport data={data} ref={_export}>
            <Grid
                data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
                style={{ height: "100%" }}
                sortable={true}
                sort={sort}
                onSortChange={(e) => {
                    setSort(e.sort);
                }}
                filterable={true}
                filter={filter}
                onFilterChange={filterChange}
                onRowClick = {(event:GridRowClickEvent)=>props.clickHandler(event.dataItem.id)}
                pageable={true}
                onPageChange={pageChange}
                skip={page.skip}
                take={page.take}
                total={data.length}
            >
                <GridToolbar>
                    <Menu
                        openOnClick={true}
                        onSelect={excelExport}
                        linkRender={linkRender}
                    >
                        <MenuItem
                            text=""
                            icon="more-horizontal"
                            data={{}}
                            cssStyle={{ color: "black" }}
                        >
                            <MenuItem text="Export to Excel" />
                        </MenuItem>
                    </Menu>
                </GridToolbar>
                <GridColumn field="customerName" title="Customer" width="200px" />
                <GridColumn field="id" title="Selection" width="250x" />
                <GridColumn field="country" title="Country" width="100px" />
                <GridColumn field="count" title="Count" width="150px" />
            </Grid>
         </ExcelExport>
    );
};
export default RunningPeriodsGrid;
